/**
 * @generated SignedSource<<223c7f1b9ba70b61678177b61d77f77a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type TeamProfileEmbedQuery$variables = {
  after?: string | null;
  cloudId?: string | null;
  currentGoalQuery: string;
  currentProjectQuery: string;
  first?: number | null;
  teamId: string;
  workspaceUuid: string;
};
export type TeamProfileEmbedQuery$data = {
  readonly teamByTeamId: {
    readonly name: string | null;
    readonly teamDetails: {
      readonly description: string | null;
      readonly name: string | null;
    } | null;
    readonly teamId: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"TeamEmbedMembers">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"TeamEmbedProjectsAndGoals_data">;
};
export type TeamProfileEmbedQuery = {
  response: TeamProfileEmbedQuery$data;
  variables: TeamProfileEmbedQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "currentGoalQuery"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "currentProjectQuery"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "teamId"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workspaceUuid"
},
v7 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "teamId",
    "variableName": "teamId"
  }
],
v8 = {
  "kind": "ScalarField",
  "name": "name"
},
v9 = {
  "concreteType": "TeamDetails",
  "kind": "LinkedField",
  "name": "teamDetails",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "description"
    },
    (v8/*: any*/)
  ]
},
v10 = {
  "kind": "ScalarField",
  "name": "teamId"
},
v11 = {
  "kind": "Variable",
  "name": "after",
  "variableName": "after"
},
v12 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v13 = {
  "kind": "Variable",
  "name": "workspaceUuid",
  "variableName": "workspaceUuid"
},
v14 = {
  "kind": "ScalarField",
  "name": "picture"
},
v15 = {
  "kind": "ScalarField",
  "name": "id"
},
v16 = {
  "kind": "ScalarField",
  "name": "key"
},
v17 = {
  "kind": "ScalarField",
  "name": "uuid"
},
v18 = {
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "owner",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "aaid"
    },
    {
      "concreteType": "UserPII",
      "kind": "LinkedField",
      "name": "pii",
      "plural": false,
      "selections": [
        (v14/*: any*/),
        (v8/*: any*/),
        {
          "kind": "ScalarField",
          "name": "accountStatus"
        }
      ]
    },
    (v15/*: any*/)
  ]
},
v19 = {
  "kind": "ScalarField",
  "name": "label"
},
v20 = [
  {
    "kind": "ScalarField",
    "name": "messageId"
  }
],
v21 = {
  "concreteType": "LocalizationField",
  "kind": "LinkedField",
  "name": "localizedLabel",
  "plural": false,
  "selections": (v20/*: any*/)
},
v22 = {
  "kind": "ScalarField",
  "name": "value"
},
v23 = [
  {
    "kind": "Literal",
    "name": "longFormat",
    "value": true
  }
],
v24 = {
  "concreteType": "TargetDate",
  "kind": "LinkedField",
  "name": "dueDate",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "confidence"
    },
    (v19/*: any*/),
    (v21/*: any*/),
    {
      "alias": "tooltip",
      "args": (v23/*: any*/),
      "kind": "ScalarField",
      "name": "label",
      "storageKey": "label(longFormat:true)"
    },
    {
      "alias": "localizedTooltip",
      "args": (v23/*: any*/),
      "concreteType": "LocalizationField",
      "kind": "LinkedField",
      "name": "localizedLabel",
      "plural": false,
      "selections": (v20/*: any*/),
      "storageKey": "localizedLabel(longFormat:true)"
    },
    {
      "kind": "ScalarField",
      "name": "overdue"
    }
  ]
},
v25 = {
  "kind": "ScalarField",
  "name": "score"
},
v26 = {
  "args": [
    {
      "kind": "Literal",
      "name": "includeScore",
      "value": false
    }
  ],
  "kind": "ScalarField",
  "name": "label",
  "storageKey": "label(includeScore:false)"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "name": "TeamProfileEmbedQuery",
    "selections": [
      {
        "args": (v7/*: any*/),
        "concreteType": "Team",
        "kind": "LinkedField",
        "name": "teamByTeamId",
        "plural": false,
        "selections": [
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          {
            "kind": "FragmentSpread",
            "name": "TeamEmbedMembers"
          }
        ]
      },
      {
        "args": [
          (v11/*: any*/),
          {
            "kind": "Variable",
            "name": "currentGoalQuery",
            "variableName": "currentGoalQuery"
          },
          {
            "kind": "Variable",
            "name": "currentProjectQuery",
            "variableName": "currentProjectQuery"
          },
          (v12/*: any*/),
          (v13/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "TeamEmbedProjectsAndGoals_data"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v5/*: any*/),
      (v6/*: any*/),
      (v4/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "TeamProfileEmbedQuery",
    "selections": [
      {
        "args": (v7/*: any*/),
        "concreteType": "Team",
        "kind": "LinkedField",
        "name": "teamByTeamId",
        "plural": false,
        "selections": [
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          {
            "concreteType": "TeamMemberConnection",
            "kind": "LinkedField",
            "name": "members",
            "plural": false,
            "selections": [
              {
                "concreteType": "TeamMemberEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TeamMember",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "UserPII",
                        "kind": "LinkedField",
                        "name": "pii",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          (v14/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "accountId"
                          },
                          {
                            "concreteType": "ExtendedProfile",
                            "kind": "LinkedField",
                            "name": "extendedProfile",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "jobTitle"
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          (v15/*: any*/)
        ]
      },
      {
        "alias": "currentProjects",
        "args": [
          (v11/*: any*/),
          (v12/*: any*/),
          {
            "kind": "Variable",
            "name": "q",
            "variableName": "currentProjectQuery"
          },
          {
            "kind": "Literal",
            "name": "sort",
            "value": [
              "STATUS_ASC",
              "TARGET_DATE_ASC"
            ]
          },
          (v13/*: any*/)
        ],
        "concreteType": "ProjectConnection",
        "kind": "LinkedField",
        "name": "projectTql",
        "plural": false,
        "selections": [
          {
            "concreteType": "ProjectEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "Project",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v8/*: any*/),
                  (v17/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "private"
                  },
                  {
                    "concreteType": "IconURIs",
                    "kind": "LinkedField",
                    "name": "iconUrl",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "ThemeURIs",
                        "kind": "LinkedField",
                        "name": "square",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "light"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "dark"
                          }
                        ]
                      }
                    ]
                  },
                  (v18/*: any*/),
                  {
                    "concreteType": "ProjectState",
                    "kind": "LinkedField",
                    "name": "state",
                    "plural": false,
                    "selections": [
                      (v19/*: any*/),
                      (v21/*: any*/),
                      {
                        "alias": "projectStateValue",
                        "kind": "ScalarField",
                        "name": "value"
                      },
                      {
                        "concreteType": "CompletionProjectState",
                        "kind": "LinkedField",
                        "name": "atCompletionState",
                        "plural": false,
                        "selections": [
                          (v22/*: any*/),
                          (v19/*: any*/),
                          (v21/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v24/*: any*/)
                ]
              }
            ]
          }
        ]
      },
      {
        "alias": "currentGoals",
        "args": [
          (v11/*: any*/),
          (v12/*: any*/),
          {
            "kind": "Variable",
            "name": "q",
            "variableName": "currentGoalQuery"
          },
          {
            "kind": "Literal",
            "name": "sorts",
            "value": [
              "SCORE_ASC",
              "TARGET_DATE_ASC"
            ]
          },
          (v13/*: any*/)
        ],
        "concreteType": "GoalConnection",
        "kind": "LinkedField",
        "name": "goalTql",
        "plural": false,
        "selections": [
          {
            "concreteType": "GoalEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "Goal",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v15/*: any*/),
                  (v17/*: any*/),
                  (v16/*: any*/),
                  {
                    "concreteType": "GoalState",
                    "kind": "LinkedField",
                    "name": "state",
                    "plural": false,
                    "selections": [
                      (v25/*: any*/),
                      (v22/*: any*/),
                      (v26/*: any*/),
                      (v21/*: any*/),
                      {
                        "alias": "goalStateValue",
                        "kind": "ScalarField",
                        "name": "value"
                      },
                      {
                        "concreteType": "CompletionGoalState",
                        "kind": "LinkedField",
                        "name": "atCompletionState",
                        "plural": false,
                        "selections": [
                          (v26/*: any*/),
                          (v21/*: any*/),
                          (v22/*: any*/),
                          (v25/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v8/*: any*/),
                  (v18/*: any*/),
                  (v24/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "hasSubgoalMatches"
                  },
                  {
                    "concreteType": "GoalConnection",
                    "kind": "LinkedField",
                    "name": "subGoals",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "GoalEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "__typename"
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "38da9248afaffb7d5d34b281f1f00b7d",
    "id": null,
    "metadata": {},
    "name": "TeamProfileEmbedQuery",
    "operationKind": "query",
    "text": "query TeamProfileEmbedQuery(\n  $teamId: String!\n  $workspaceUuid: UUID!\n  $first: Int\n  $after: String\n  $currentProjectQuery: String!\n  $currentGoalQuery: String!\n  $cloudId: String\n) {\n  teamByTeamId(teamId: $teamId, cloudId: $cloudId) {\n    name\n    teamDetails {\n      description\n      name\n    }\n    teamId\n    ...TeamEmbedMembers\n    id\n  }\n  ...TeamEmbedProjectsAndGoals_data_2tbZqi\n}\n\nfragment GoalEmbedRow on Goal {\n  ...GoalName\n  id\n  owner {\n    ...UserAvatar_1cDMtx\n    id\n  }\n  state {\n    ...GoalState\n  }\n  dueDate {\n    ...TargetDate\n  }\n  hasSubgoalMatches\n  subGoals {\n    edges {\n      __typename\n    }\n  }\n}\n\nfragment GoalIcon on Goal {\n  state {\n    score\n    value\n  }\n}\n\nfragment GoalName on Goal {\n  uuid\n  id\n  key\n  ...GoalIcon\n  name\n}\n\nfragment GoalState on GoalState {\n  label(includeScore: false)\n  localizedLabel {\n    messageId\n  }\n  score\n  goalStateValue: value\n  atCompletionState {\n    label(includeScore: false)\n    localizedLabel {\n      messageId\n    }\n    value\n    score\n  }\n}\n\nfragment ProjectEmbedRow on Project {\n  ...ProjectName_data\n  owner {\n    ...UserAvatar_1cDMtx\n    id\n  }\n  state {\n    ...ProjectState\n  }\n  dueDate {\n    ...TargetDate\n  }\n}\n\nfragment ProjectIcon on Project {\n  private\n  iconUrl {\n    square {\n      light\n      dark\n    }\n  }\n}\n\nfragment ProjectName_data on Project {\n  id\n  key\n  name\n  uuid\n  ...ProjectIcon\n}\n\nfragment ProjectState on ProjectState {\n  label\n  localizedLabel {\n    messageId\n  }\n  projectStateValue: value\n  atCompletionState {\n    value\n    label\n    localizedLabel {\n      messageId\n    }\n  }\n}\n\nfragment TargetDate on TargetDate {\n  confidence\n  label\n  localizedLabel {\n    messageId\n  }\n  tooltip: label(longFormat: true)\n  localizedTooltip: localizedLabel(longFormat: true) {\n    messageId\n  }\n  overdue\n}\n\nfragment TeamEmbedMembers on Team {\n  members {\n    edges {\n      node {\n        pii {\n          name\n          picture\n          accountId\n          extendedProfile {\n            jobTitle\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment TeamEmbedProjectsAndGoals_data_2tbZqi on Query {\n  currentProjects: projectTql(first: $first, after: $after, workspaceUuid: $workspaceUuid, q: $currentProjectQuery, sort: [STATUS_ASC, TARGET_DATE_ASC]) {\n    edges {\n      node {\n        id\n        ...ProjectEmbedRow\n      }\n    }\n  }\n  currentGoals: goalTql(first: $first, after: $after, workspaceUuid: $workspaceUuid, q: $currentGoalQuery, sorts: [SCORE_ASC, TARGET_DATE_ASC]) {\n    edges {\n      node {\n        id\n        ...GoalEmbedRow\n      }\n    }\n  }\n}\n\nfragment UserAvatar_1cDMtx on User {\n  aaid\n  pii {\n    picture\n    name\n    accountStatus\n  }\n}\n"
  }
};
})();

(node as any).hash = "e4e6b43825b81b5c6897edce3c7ee2fd";

export default node;
